<template>
    <MainPage :theme="theme">
        <template #header>
            <Topbar :theme="theme" :appName="state.appName" @onClickBack="onClickBack()"></Topbar>
        </template>
        <template #content>
            <div class="px-4 -mt-8">
                <div class="min-h-screen h-full rounded-t-3xl w-full bg-white text-semi">
                    <div class="pt-8 text-center px-4">
                        <div class="text-18" :style="state.textTitle">{{ title }}</div>
                        <div class="mt-2 text-16 text-black">{{ subTitle }}</div>

                        <!-- SearchBox -->
                        <div class="w-full max-w-lg mx-auto mt-4">
                            <div class="relative px-4 py-2.5 rounded-50px border w-full flex flex-row gap-2 items-center"
                                :style="searchBoxStyle">
                                <div class="flex items-center">
                                    <img src="../assets/icon/ic-search.svg" alt="Search" class="w-5 h-5" :style="{ minWidth: '20px'}" />
                                </div>
                                <div class="w-px h-5" :style="dividerStyle"></div>

                                <!-- Input -->
                                <input type="text" v-model="state.searchBox.searchQuery"
                                    class="w-full border-none! border-0! focus:outline-none text-16 font-medium"
                                    :style="inputStyle"
                                    :placeholder="'Search by Name'"
                                    @focus="isInputFocused = true"
                                    @blur="isInputFocused = false; !state.searchBox.searchQuery ? searchText() : null"
                                    @keyup.enter="searchText">

                                <!-- Search Btn - Only show when typing/focused -->
                                <div v-if="state.searchBox.searchQuery"
                                    class="font-semibold text-16 text-center cursor-pointer"
                                    :style="{ color: state.searchBox.typingBorderColor }"
                                    @click="searchText">
                                    Search
                                </div>
                            </div>
                        </div>

                        <div class="w-full min-w-[320px] max-w-lg mx-auto mt-5" v-if="banner">
                            <img class="rounded-xl" :src="banner" alt="">
                        </div>
                        <div class="border-b border-a-gray-dfdfdf w-full mt-4"></div>
                    </div>
                    <div class="p-5">
                        <div v-for="(detail, index) of detailInfo" :key="index">
                            <div class="text-16">{{ detail.title }}</div>
                            <div class="text-14 my-3" :style="state.textPrize">{{ detail.detail }}</div>
                            <div class="w-full min-w-[320px] max-w-lg mx-auto" v-if="detail.image_url">
                                <img class="rounded-xl m-auto" :src="detail.image_url" alt="">
                            </div>
                            <div class="flex justify-between my-6 text-black text-14" 
                                v-for="(item, k) of detail.winners"
                                :key="k"
                                :id="`winner-${index}-${k}`"
                                :ref="el => { if (el) winnerRefs[`winner-${index}-${k}`] = el }">
                                <div :class="[item.description.length < 20 ? '' : 'xs-min-max:w-36 w-48 usm:w-10/12']">
                                    <div>{{ k + 1 }}.
                                        <span class="ml-1 break-all">{{ splitNameFormat(item.description) }}</span>
                                    </div>
                                </div>
                                <div>{{ splitTelFormat(item.description) }}</div>
                            </div>
                            <div
                                :class="[index == detailInfo.length - 1 ? '' : 'border-b border-a-gray-dfdfdf w-full my-4']">
                            </div>
                        </div>

                        <div v-if="isShowNotFound" class="mt-10 text-center font-medium text-20 text-opacity-80" :style="state.textTitle">
                            Sorry, We didn't find your name this time.
                        </div>
                    </div>
                </div>
            
            </div>
        </template>
    </MainPage>
</template>
<script>
import { reactive, ref, computed } from "vue";
import { useRoute } from "vue-router";
import AnnouncementService from "../service/AnnouncementService.js"
import MainPage from "../component/Layout/MainPage.vue"
import Topbar from "../component/Topbar/Topbar.vue"
import BzbsApiLegacy from "@/core/Http/BzbsApiLegacy"
import Utility from "@/helper/Utility";
export default {
    name: 'Announcement',
    components: {
        MainPage,
        Topbar
    },
    setup: function () {
        const route = useRoute()
        const state = reactive({
            appName: route.query.app_name,
            appId: route.query.appId,
            round: route.query.round,
            returnUrl: route.query.return_url,
            backgroundStyle: {
                backgroundColor: '',
            },
            textTitle: {
                color: ''
            },
            textPrize: {
                color: ''
            },
            searchBox: {
                searchQuery: '',
            },
        })

        const isInputFocused = ref(false);
        const winnerRefs = ref({});
        const searchResults = ref([]);

        // Computed properties for search box styling
        const searchBoxStyle = computed(() => {
            let backgroundColor = '';
            let borderColor = '';
            if (isInputFocused.value) {
                // Typing state
                backgroundColor = state.searchBox.typingBackgroundColor;
                if(state.searchBox.searchQuery){
                    borderColor = state.searchBox.typingBorderColor;
                }else{
                    borderColor = state.searchBox.borderColor;
                }
            } else if (state.searchBox.searchQuery) {
                // Filled state
                backgroundColor = state.searchBox.filledBackgroundColor;
                borderColor = state.searchBox.filledBorderColor;
            } else {
                // Normal state
                backgroundColor = state.searchBox.backgroundColor;
                borderColor = state.searchBox.borderColor;
            }
            
            return {
                backgroundColor: backgroundColor,
                borderColor: borderColor
            };
        });

        // Computed property for divider styling
        const dividerStyle = computed(() => {
            let backgroundColor = '';
            if (isInputFocused.value) {
                // Typing state
                backgroundColor = state.searchBox.typingDividerColor;
            } else if (state.searchBox.searchQuery) {
                // Filled state
                backgroundColor = state.searchBox.filledDividerColor;
            } else {
                // Normal state
                backgroundColor = state.searchBox.dividerColor;
            }
            
            return {
                backgroundColor
            };
        });

        // Computed property for input styling
        const inputStyle = computed(() => {
            let color = '';
            if (isInputFocused.value) {
                // Typing state
                color = state.searchBox.typingContentColor;
            } else if (state.searchBox.searchQuery) {
                // Filled state
                color = state.searchBox.filledContentColor;
            } else {
                // Normal state
                color = state.searchBox.textColor;
            }
            
            return {
                color
            };
        });

        return {
            route: route,
            state: state,
            isInputFocused,
            winnerRefs,
            searchResults,
            // Export computed classes
            searchBoxStyle,
            dividerStyle,
            inputStyle
        }
    },
    data: function () {
        return {
            theme: null,
            announceInfo: null,
            detailInfo: '',
            title: '',
            subTitle: '',
            banner: '',
            blobWebLanding: '',
            isShowNotFound: false,
        }
    }, 
    created: async function () {
        await this.getThemeBlob();
        const blobPath = this.getBlobApiConfig(this.state) 
        await this.getWebLanding(blobPath);
    },
    methods: {
        getBlobApiConfig: function () {
            const app_id = this.state.appId || Utility.getParameterByName("appId");
            const version = 2;
            const blob_path = Utility.getUrlBlobJsonFromTheme(app_id, version);
            return blob_path;
        },
        getWebLanding: function (blob_path) {
            return new Promise((resolve, reject) => {
                BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blob_path).then((res_config) => {
                    this.blobWebLanding = res_config
                    this.getDashboardAnnouncement(this.blobWebLanding)
                    resolve(this.blobWebLanding)
                }).catch((err) => {
                    console.log(err)
                    this.blobWebLanding = null
                    reject(err)
                });
            });
        },
        getThemeBlob: function () {
            return new Promise((resolve) => {
                AnnouncementService.apiGetThemeContent(this.state.appId).subscribe({
                    next: async (data) => {
                        this.theme = await data;
                        this.state.textTitle.color = data.color_1
                        this.state.textPrize.color = data.color_2

                        // Add search box theme color from blob
                        this.state.searchBox = {
                            searchQuery: '',
                            
                            // Normal state
                            backgroundColor: data.search_box?.['normal-background'] || '#ffffff',
                            borderColor: data.search_box?.['normal-border'] || '#D1D1D1',
                            dividerColor: data.search_box?.['normal-divider'] || '#D1D1D1',
                            placeholderColor: data.search_box?.['normal-placeholder'] || '#D1D1D1',

                            // Typing state
                            typingBackgroundColor: data.search_box?.['typing-background'] || '#ffffff',
                            typingBorderColor: data.search_box?.['typing-border'] || data.color_1,
                            typingDividerColor: data.search_box?.['typing-divider'] || '#D1D1D1',
                            typingPlaceholderColor: data.search_box?.['typing-placeholder'] || '#D1D1D1',
                            typingContentColor: data.search_box?.['typing-content'] || '#3A3A3A',

                            // Filled state
                            filledBackgroundColor: data.search_box?.['filled-background'] || '#ffffff',
                            filledBorderColor: data.search_box?.['filled-border'] || '#D1D1D1',
                            filledDividerColor: data.search_box?.['filled-divider'] || '#D1D1D1',
                            filledPlaceholderColor: data.search_box?.['filled-placeholder'] || '#D1D1D1',
                            filledContentColor: data.search_box?.['filled-content'] || '#3A3A3A',
                            
                            // For text color in normal state
                            textColor: data.search_box?.['normal-placeholder'] || '#D1D1D1'
                        }

                        resolve(data);
                    },
                    error: (err) => {
                        console.log(err);
                    },
                })
            });
        },
        getDashboardAnnouncement: function (blobWebLanding) {
            return new Promise((resolve) => {
                AnnouncementService.apiGetDashboardAnnouncement(this.state, blobWebLanding).subscribe({
                    next: async (res) => {
                        this.announceInfo = await res.data;
                        this.title = this.announceInfo.title_header;
                        this.subTitle = this.announceInfo.subtitle_header;
                        this.banner = this.announceInfo.banner;
                        this.detailInfo = this.announceInfo.winner_list_detail;

                        resolve(res);
                    },
                    error: (err) => {
                        console.log(err);
                    },
                })
            });
        },
        onClickBack: function () {
            window.location.replace(this.state.returnUrl)
        },
        splitNameFormat: function(strName) {
            return Utility.splitNameFormat(strName);
        },
        splitTelFormat: function(strName) {
            return Utility.splitTelFormat(strName);
        },
        searchText: function () {
            // Reset search first
            this.searchResults = [];
            this.isShowNotFound = false;
            
            const query = this.state.searchBox.searchQuery.trim().toLowerCase();
            
            // If no search query, show all winners
            if (!query) {
                this.showAllWinners();
                return;
            }
            
            // Hide all winners first
            this.hideAllWinners();
            
            // Loop to find text matching the query
            this.detailInfo.forEach((detail, detailIndex) => {
                if (detail.winners && detail.winners.length > 0) {
                    detail.winners.forEach((winner, winnerIndex) => {
                        const winnerID = `winner-${detailIndex}-${winnerIndex}`;
                        const winnerEl = this.winnerRefs[winnerID];
                        
                        if (winnerEl) {
                            // Get the winner text content
                            const nameText = this.splitNameFormat(winner.description).toLowerCase();
                            const telText = this.splitTelFormat(winner.description).toLowerCase();
                            const fullText = `${nameText} ${telText}`;
                            
                            // Check if query is found 
                            if (fullText.includes(query)) {
                                // Show element for matched winner
                                winnerEl.style.display = 'flex';
                                
                                // Add to search results
                                this.searchResults.push({
                                    id: winnerID,
                                    element: winnerEl,
                                    text: fullText,
                                    detailIndex: detailIndex,
                                    winnerIndex: winnerIndex
                                });
                            }
                        }
                    });
                }
            });
            
            if (this.searchResults.length === 0) {
                this.isShowNotFound = true;
            }
        },
        
        hideAllWinners: function() {
            // Hide all winner elements
            this.detailInfo.forEach((detail, detailIndex) => {
                if (detail.winners && detail.winners.length > 0) {
                    detail.winners.forEach((winner, winnerIndex) => {
                        const winnerID = `winner-${detailIndex}-${winnerIndex}`;
                        const winnerEl = this.winnerRefs[winnerID];
                        
                        if (winnerEl) {
                            winnerEl.style.display = 'none';
                        }
                    });
                }
            });
        },
        
        showAllWinners: function() {
            // Show all winner elements
            this.detailInfo.forEach((detail, detailIndex) => {
                if (detail.winners && detail.winners.length > 0) {
                    detail.winners.forEach((winner, winnerIndex) => {
                        const winnerID = `winner-${detailIndex}-${winnerIndex}`;
                        const winnerEl = this.winnerRefs[winnerID];
                        
                        if (winnerEl) {
                            winnerEl.style.display = 'flex';
                        }
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../style/main.scss";
@import '../style/base.scss';
</style>

